<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <div class="text-sm-center" style="margin-top: 100px">
        <h1>404 - Seite nicht gefunden</h1>
        <p class="lead">Die gewünschte Seite konnte leider nicht gefunden werden.</p>
      </div>
    </div>
  </div>
</div>
